<template>
  <div class="container">
    <CdsMenu @menuSelect="menuSelect"/>
     <div class="body">
       <div style="display: flex">
         <div style="width: 72%">
           <div class="big-title" data-aos="fade-up">
             HoloData全息专病数据库管理平台
             <div class="title-line"></div>
             <div class="title-des">
               HoloData全息专病数据库管理平台以临床业务信息系统或集成整合后的临床数据为数据源，经“抽取-转换-加载”后形成标准资源库，在此基础上，通过自然语言处理、数据映射等构建专病数据库和课题数据库，主要功能模块包括数据采集、数据治理、统计分析、科研分析、课题研究、患者360°全息视图等。平台基于公司在医疗数据治理方面的丰富经验，并采用由OHDSI提出的国际先进的OMOP通用数据模型来建立大数据中心，通过隐私安全技术解决数据价值的流通问题，可集成多源异构数据，通过数据标准化、AI数据治理等实现数据应用，专业医学人才协助制定专病数据集、纳排专病人群等，最终实现科研应用，从而提高医院的医疗服务质量和科研水平，促进医学成果转化，推动全民健康事业的发展。
             </div>
           </div>
         </div>
         <div style="margin-left: 10px" data-aos="fade-up">
           <img src="../../assets/img/database/holoData/1.png" style="width: 450px"/>
         </div>
       </div>
       <div class="body-title" data-aos="fade-up">系统架构</div>
       <div data-aos="fade-up">
         <img  src="../../assets/img/database/holoData/2.png" style="width: 100%"/>
       </div>
       <div class="body-title" data-aos="fade-up">功能示例</div>
       <div style="width: 100%" class="card-img" data-aos="fade-up">
         <el-carousel :interval="5000" arrow="always">
           <el-carousel-item >
             <img  src="../../assets/img/database/holoData/8.png" style="width: 100%"/>
           </el-carousel-item>
           <el-carousel-item >
             <img  src="../../assets/img/database/holoData/9.png" style="width: 100%"/>
           </el-carousel-item>
           <el-carousel-item >
             <img  src="../../assets/img/database/holoData/10.png" style="width: 100%"/>
           </el-carousel-item>
         </el-carousel>
       </div>

<!--       <div >-->
<!--         <img  src="../../assets/img/database/holoData/6.png" style="width: 100%"/>-->
<!--       </div>-->
<!--       <div class="linear">-->
<!--         <div class="left">-->
<!--           <div class="arrow-left"></div>-->
<!--         </div>-->
<!--         <div class="content">-->
<!--           <div class="body">-->
<!--             <div class="left-img">-->
<!--               <img  src="../../assets/img/database/holoData/7.png" style="width: 100%"/>-->
<!--             </div>-->
<!--             <div class="right-table">-->
<!--               <div style="display: flex;justify-content: center;font-size: 20px;position: relative;top: -10px">采集全流程各场景的数据</div>-->
<!--               <div class="table-border">-->
<!--                 <div class="col">-->
<!--                  <div class="table">-->
<!--                    <div class="title center">病历</div>-->
<!--                    <div class="row center">病案首页</div>-->
<!--                    <div class="row center">入院记录</div>-->
<!--                    <div class="row center">首程</div>-->
<!--                    <div class="row center">日常病程</div>-->
<!--                    <div class="row center">查房记录</div>-->
<!--                    <div class="row center">转科记录</div>-->
<!--                    <div class="row center">抢救记录</div>-->
<!--                    <div class="row center">会诊记录</div>-->
<!--                    <div class="row center">死亡记录</div>-->
<!--                    <div class="row center">出院记录</div>-->
<!--                    <div class="row center">门急诊</div>-->
<!--                    <div class="row center">急诊留现</div>-->
<!--                  </div>-->
<!--                  <div class="table" style="margin-top: 7px">-->
<!--                    <div class="title center">手术</div>-->
<!--                    <div class="row center">术前访视</div>-->
<!--                    <div class="row center">麻醉记录</div>-->
<!--                    <div class="row center">术后访视</div>-->
<!--                    <div class="row center">手术记录</div>-->
<!--                  </div>-->
<!--                 </div>-->
<!--                 <div class="col">-->
<!--                   <div class="table">-->
<!--                     <div class="title center">处方/医嘱</div>-->
<!--                     <div class="row center">药品类</div>-->
<!--                     <div class="row center">非药品类</div>-->
<!--                   </div>-->
<!--                   <div class="table" style="margin-top: 10px">-->
<!--                     <div class="title center">护理/重症</div>-->
<!--                     <div class="row center">生命体征</div>-->
<!--                     <div class="row center">护理观察</div>-->
<!--                     <div class="row center">护理操作</div>-->
<!--                     <div class="row center">护理记录</div>-->
<!--                     <div class="row center">管路记录</div>-->
<!--                     <div class="row center">入院评估</div>-->
<!--                     <div class="row center">出院评估</div>-->
<!--                     <div class="row center">护理计划</div>-->
<!--                     <div class="row center">评分</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 10px">-->
<!--                     <div class="title center">介入导管</div>-->
<!--                     <div class="row center">检查管理</div>-->
<!--                     <div class="row center">介入报告</div>-->
<!--                     <div class="row center">生理监测</div>-->
<!--                   </div>-->
<!--                 </div>-->
<!--                 <div class="col">-->
<!--                   <div class="table">-->
<!--                     <div class="title center">检验</div>-->
<!--                     <div class="row center">检验</div>-->
<!--                     <div class="row center">微生物</div>-->
<!--                     <div class="row center">基因</div>-->
<!--                     <div class="row center">HLA</div>-->
<!--                     <div class="row center">骨穿</div>-->
<!--                   </div>-->
<!--                   <div class="table" style="margin-top: 2px">-->
<!--                     <div class="title center">检查</div>-->
<!--                     <div class="row center">检查管理</div>-->
<!--                     <div class="row center">检查报告</div>-->
<!--                   </div>-->
<!--                   <div class="table" style="margin-top: 2px">-->
<!--                     <div class="title center">肺功能检查</div>-->
<!--                     <div class="row center">检肺功能</div>-->
<!--                     <div class="row center">运动心肺</div>-->
<!--                     <div class="row center">血气</div>-->
<!--                     <div class="row center">过敏源</div>-->
<!--                     <div class="row center">呼出气一氧化碳</div>-->
<!--                     <div class="row center">激发试验</div>-->
<!--                     <div class="row center">纤支镜源</div>-->
<!--                     <div class="row center">咳嗽实验室</div>-->
<!--                   </div>-->
<!--                 </div>-->
<!--                 <div class="col">-->
<!--                   <div class="table">-->
<!--                     <div class="title center">输血</div>-->
<!--                     <div class="row center">输血观察</div>-->
<!--                     <div class="row center">评价</div>-->
<!--                     <div class="row center">不良反应</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 5px">-->
<!--                     <div class="title center">病理</div>-->
<!--                     <div class="row center">病理管理</div>-->
<!--                     <div class="row center">病理报告</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 5px">-->
<!--                     <div class="title center">透析</div>-->
<!--                     <div class="row center">病历记录</div>-->
<!--                     <div class="row center">护理记录</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 5px">-->
<!--                     <div class="title center">放疗</div>-->
<!--                     <div class="row center">放疗记录</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 5px">-->
<!--                     <div class="title center">康复</div>-->
<!--                     <div class="row center">康复病历</div>-->
<!--                     <div class="row center">评测评定</div>-->
<!--                     <div class="row center">治疗处方</div>-->
<!--                   </div>-->
<!--                 </div>-->
<!--                 <div class="col">-->
<!--                   <div class="table" >-->
<!--                     <div class="title center">健康管理</div>-->
<!--                     <div class="row center">问卷调查</div>-->
<!--                     <div class="row center">体检记录</div>-->
<!--                     <div class="row center">监测记录</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 5px">-->
<!--                     <div class="title center">医院管理</div>-->
<!--                     <div class="row center">病人</div>-->
<!--                     <div class="row center">就诊</div>-->
<!--                     <div class="row center">诊断</div>-->
<!--                     <div class="row center">临床路径</div>-->
<!--                     <div class="row center">转科</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 5px">-->
<!--                     <div class="title center">随访</div>-->
<!--                     <div class="row center">随访计划</div>-->
<!--                     <div class="row center">随访记录</div>-->
<!--                     <div class="row center">结果质控</div>-->
<!--                   </div>-->
<!--                   <div class="table"  style="margin-top: 5px">-->
<!--                     <div class="title center">费用</div>-->
<!--                     <div class="row center">发票</div>-->
<!--                     <div class="row center">费用明细</div>-->
<!--                   </div>-->
<!--                 </div>-->
<!--               </div>-->
<!--             </div>-->
<!--           </div>-->
<!--         </div>-->
<!--         <div class="right">-->
<!--           <div class="arrow-right"></div>-->
<!--         </div>-->
<!--       </div>-->
       <div class="body-title" data-aos="fade-up">技术优势</div>
       <div data-aos="fade-up" >
         <img  src="../../assets/img/database/holoData/3.png" style="width: 100%"/>
       </div>
       <div class="body-title" data-aos="fade-up">功能优势</div>
       <div data-aos="fade-up">
         <img  src="../../assets/img/database/holoData/4.png" style="width: 100%"/>
       </div>
       <div class="body-title" data-aos="fade-up">应用价值</div>
       <div data-aos="fade-up">
         <img  src="../../assets/img/database/holoData/5.png" style="width: 120%;position: relative;left: -10%"/>
       </div>
       <div class="body-title" data-aos="fade-up">典型案例</div>
       <div data-aos="fade-up">
          <div class="backColor">
            <el-carousel indicator-position="outside">
              <el-carousel-item>
                   <div class="card-body">
                         <div class="left">
                           <div class="title">基于专病数据集的多中心临床研究协作项目<br/>(复旦大学上海医学院)</div>
                           <div class="time">
                             <img  src="../../assets/img/database/holoData/13.png" style="width: 35px;margin-right: 15px"/>启动时间：2020年
                           </div>
                           <div class="time">
                             <img  src="../../assets/img/database/holoData/14.png" style="width: 35px;margin-right: 15px"/>关键词：专病数据集、临床科研
                           </div>
                         </div>
                     <div class="right">
                       <img   src="../../assets/img/database/holoData/15.png" style="width: 100%;position: relative;top: 4%"/>
                     </div>
                   </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="card-body">
                  <div class="left">
                    <div class="title">肝癌数据治理项目<br/>(复旦大学上海医学院联合中山医院)</div>
                    <div class="time">
                      <img  src="../../assets/img/database/holoData/13.png" style="width: 35px;margin-right: 15px"/>启动时间：2021年
                    </div>
                    <div class="time">
                      <img  src="../../assets/img/database/holoData/14.png" style="width: 35px;margin-right: 15px"/>关键词：数据治理、多中心临床研究
                    </div>
                  </div>
                  <div class="right">
                    <img   src="../../assets/img/database/holoData/16.png" style="width: 100%;position: relative;top: 4%"/>
                  </div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="card-body">
                  <div class="left">
                    <div class="title">多中心专病研究平台 (河北医科大学)</div>
                    <div class="time">
                      <img  src="../../assets/img/database/holoData/13.png" style="width: 35px;margin-right: 15px"/>启动时间：2023年
                    </div>
                    <div class="time">
                      <img  src="../../assets/img/database/holoData/14.png" style="width: 35px;margin-right: 15px"/>关键词：专病研究、多中心参与、资源条件性共享
                    </div>
                  </div>
                  <div class="right">
                    <img   src="../../assets/img/database/holoData/17.png" style="width: 100%;position: relative;top: 4%"/>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
       </div>
     </div>
  </div>
</template>

<script>
import CdsMenu from "@/components/CdsMenu";
export default {
  name: "holoData",
  data(){
    return{
      imgList:[8,9,10,11,12]
    }
  },
  components: {CdsMenu},
  methods:{
    menuSelect(src){
      this.$emit('menuSelect',src)
    }
  }
}
</script>

<style scoped lang="less" src="./less/holoData.less">
</style>